/* eslint-disable max-len */
class ProductFeatures extends HTMLElement {
	constructor() {
		super();
		this.featureListContainer = this.querySelector(
			".product-feature--container",
		);
		this.productTags = this.dataset.productTags.split(",");
		this.featureJSON = JSON.parse(
			document.getElementById("productFeatureJSON").textContent,
		);
		this.generateFeatureContent();
	}

	generateFeatureContent() {
		const topFeatures = [];
		const materialFeatures = [];
		const bottomFeatures = [];
		const additionalFeatures = [];

		this.productTags.forEach((tag) => {
			const footbedFeature = this.featureJSON.footbed_tags.find(
				(item) => item.tag === tag,
			);
			const liningFeature = this.featureJSON.footbed_lining_tags.find(
				(item) => item.tag === tag,
			);
			const materialFeature = this.featureJSON.materials_tags.find(
				(item) => item.tag === tag,
			);
			const soleFeature = this.featureJSON.sole_tags.find(
				(item) => item.tag === tag,
			);
			const veganFeature = this.featureJSON.vegan_tags.find(
				(item) => item.tag === tag,
			);
			const countryOriginFeature = this.featureJSON.country_origin_tags.find(
				(item) => item.tag === tag,
			);

			if (footbedFeature) {
				topFeatures.push(footbedFeature);
			}
			if (liningFeature) {
				topFeatures.push(liningFeature);
			}
			if (materialFeature) {
				materialFeatures.push(materialFeature);
			}
			if (soleFeature) {
				bottomFeatures.push(soleFeature);
			}
			if (veganFeature) {
				bottomFeatures.push(veganFeature);
			}
			if (countryOriginFeature) {
				additionalFeatures.push(countryOriginFeature);
			}
		});

		if (this.featureListContainer) {
			if (topFeatures.length > 0) {
				topFeatures.forEach((feature) => {
					this.featureListContainer.innerHTML += `<li>${feature.copy}</li>`;
				});
			}

			if (materialFeatures.length > 1) {
				let materialCopy = "Material:";
				materialFeatures.forEach((feature) => {
					materialCopy += `${feature.copy.split(":").pop()},`;
				});
				this.featureListContainer.innerHTML += `<li>${materialCopy.slice(0, -1)}</li>`;
			} else if (materialFeatures.length === 1) {
				this.featureListContainer.innerHTML += `<li>${materialFeatures[0].copy}</li>`;
			}

			if (bottomFeatures.length > 0) {
				bottomFeatures.forEach((feature) => {
					this.featureListContainer.innerHTML += `<li>${feature.copy}</li>`;
				});
			}

			if (additionalFeatures.length > 0) {
				additionalFeatures.forEach((feature) => {
					this.featureListContainer.innerHTML += `<li>${feature.copy}</li>`;
				});
			}
		}
	}
}

// eslint-disable-next-line no-unused-expressions
customElements.get("product-features") ||
	customElements.define("product-features", ProductFeatures);
